import React, { useEffect } from 'react';

import { useCommandState } from '../../../ui/command';
import { cn } from '@repo/ui/lib/utils';

export const CommandListChevron: React.FC<{
  className?: string;
  hidden?: boolean;
  children: React.JSX.Element;
  onFilteredCountChange?: () => void;
}> = ({ className, children, hidden, onFilteredCountChange }) => {
  const filteredResultCount = useCommandState(
    (state) => state?.filtered?.count,
  );

  const handleCommandChevronSectionClick = (
    event: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => event.stopPropagation();

  useEffect(() => {
    onFilteredCountChange?.();
  }, [filteredResultCount]);

  return (
    <section
      className={cn(
        'sticky flex justify-center items-center h-6 inset-x-0 bg-white z-10',
        {
          hidden: filteredResultCount <= 6 || hidden,
        },
        className,
      )}
      onClick={handleCommandChevronSectionClick}
    >
      {children}
    </section>
  );
};
